/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import Team from "./Team"; // eslint-disable-line no-unused-vars

const TeamContainer = (props) => {
    return(
       <Team/>
    )
};

export default TeamContainer;
